var keys = {
    PRE_title: "PRE_title",
    PRE_display: "PRE_display",
    PRE_themeTitle: "PRE_themeTitle",
    PRE_themeSubtitle: "PRE_themeSubtitle",
    PRE_theme_light: "PRE_theme_light",
    PRE_theme_dark: "PRE_theme_dark",
    PRE_theme_system: "PRE_theme_system",
    PRE_behavior: "PRE_behavior",
    PRE_shortcutsTitle: "PRE_shortcutsTitle",
    PRE_shortcutsSubtitle: "PRE_shortcutsSubtitle",
    PRE_shortcutsCardTitle: "PRE_shortcutsCardTitle",
    PRE_showAll: "PRE_showAll",
    PRE_back: "PRE_back",
    PRE_nextTab: "PRE_nextTab",
    PRE_prevTab: "PRE_prevTab",
    PRE_nextPage: "PRE_nextPage",
    PRE_prevPage: "PRE_prevPage",
    PRE_focusSearch: "PRE_focusSearch",
    PRE_areaGeneral: "PRE_areaGeneral",
    PRE_areaNav: "PRE_areaNav",
    PRE_areaNavAdmin: "PRE_areaNavAdmin",
    PRE_areaNumbers: "PRE_areaNumbers",
    PRE_areaTemplates: "PRE_areaTemplates",
    PRE_areaPreferences: "PRE_areaPreferences",
    PRE_integrations: "PRE_integrations",
    PRE_partners: "PRE_partners",
    PRE_showHide: "PRE_showHide",
    PRE_openTemplateManager: "PRE_openTemplateManager",
    PRE_showDetails: "PRE_showDetails",
    PRE_newTemplate: "PRE_newTemplate",
    PRE_openPreview: "PRE_openPreview",
    PRE_duplicateTemplate: "PRE_duplicateTemplate",
    PRE_addLang: "PRE_addLang",
    PRE_themeToggle: "PRE_themeToggle",
    PRE_disableShortcuts: "PRE_disableShortcuts",
    PRE_langTitle: "PRE_langTitle",
    PRE_langSubtitle: "PRE_langSubtitle",
    PRE_loadingBillingPortal: "PRE_loadingBillingPortal",
    PRE_alertNoPayment: "PRE_alertNoPayment",
    PRE_alertNoPaymentLinkLabel: "PRE_alertNoPaymentLinkLabel",
    PRE_alertNoPaymentCountry: "PRE_alertNoPaymentCountry",
    PRE_alertNoPaymentCountryLinkLabel: "PRE_alertNoPaymentCountryLinkLabel",
    PRE_copyUrl: "PRE_copyUrl",
    PRE_otherAdmin: "PRE_otherAdmin",
    PRE_cookiesChanged: "PRE_cookiesChanged",
    PRE_Privacy: "PRE_Privacy",
    PRE_changeCookies: "PRE_changeCookies",
    PRE_changeCookiesDescription: "PRE_changeCookiesDescription",
    PRE_notifications: "PRE_notifications",
    PRE_notificationsTitle: "PRE_notificationsTitle",
    PRE_notificationsDescription: "PRE_notificationsDescription",
    PRE_notificationsEmail: "PRE_notificationsEmail",
    PRE_notificationsSelect: "PRE_notificationsSelect",
    PRE_notificationsSubscribeAll: "PRE_notificationsSubscribeAll",
    PRE_notificationsUnsubscribeAll: "PRE_notificationsUnsubscribeAll",
    PRE_emailTooLong: "PRE_emailTooLong",
    PRE_notificationPreferences: "PRE_notificationPreferences",
};
export default keys;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImtleXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBTSxJQUFJLEdBQTRCO0lBQ3BDLFNBQVMsRUFBRSxXQUFXO0lBQ3RCLFdBQVcsRUFBRSxhQUFhO0lBQzFCLGNBQWMsRUFBRSxnQkFBZ0I7SUFDaEMsaUJBQWlCLEVBQUUsbUJBQW1CO0lBQ3RDLGVBQWUsRUFBRSxpQkFBaUI7SUFDbEMsY0FBYyxFQUFFLGdCQUFnQjtJQUNoQyxnQkFBZ0IsRUFBRSxrQkFBa0I7SUFDcEMsWUFBWSxFQUFFLGNBQWM7SUFDNUIsa0JBQWtCLEVBQUUsb0JBQW9CO0lBQ3hDLHFCQUFxQixFQUFFLHVCQUF1QjtJQUM5QyxzQkFBc0IsRUFBRSx3QkFBd0I7SUFDaEQsV0FBVyxFQUFFLGFBQWE7SUFDMUIsUUFBUSxFQUFFLFVBQVU7SUFDcEIsV0FBVyxFQUFFLGFBQWE7SUFDMUIsV0FBVyxFQUFFLGFBQWE7SUFDMUIsWUFBWSxFQUFFLGNBQWM7SUFDNUIsWUFBWSxFQUFFLGNBQWM7SUFDNUIsZUFBZSxFQUFFLGlCQUFpQjtJQUNsQyxlQUFlLEVBQUUsaUJBQWlCO0lBQ2xDLFdBQVcsRUFBRSxhQUFhO0lBQzFCLGdCQUFnQixFQUFFLGtCQUFrQjtJQUNwQyxlQUFlLEVBQUUsaUJBQWlCO0lBQ2xDLGlCQUFpQixFQUFFLG1CQUFtQjtJQUN0QyxtQkFBbUIsRUFBRSxxQkFBcUI7SUFDMUMsZ0JBQWdCLEVBQUUsa0JBQWtCO0lBQ3BDLFlBQVksRUFBRSxjQUFjO0lBQzVCLFlBQVksRUFBRSxjQUFjO0lBQzVCLHVCQUF1QixFQUFFLHlCQUF5QjtJQUNsRCxlQUFlLEVBQUUsaUJBQWlCO0lBQ2xDLGVBQWUsRUFBRSxpQkFBaUI7SUFDbEMsZUFBZSxFQUFFLGlCQUFpQjtJQUNsQyxxQkFBcUIsRUFBRSx1QkFBdUI7SUFDOUMsV0FBVyxFQUFFLGFBQWE7SUFDMUIsZUFBZSxFQUFFLGlCQUFpQjtJQUNsQyxvQkFBb0IsRUFBRSxzQkFBc0I7SUFDNUMsYUFBYSxFQUFFLGVBQWU7SUFDOUIsZ0JBQWdCLEVBQUUsa0JBQWtCO0lBQ3BDLHdCQUF3QixFQUFFLDBCQUEwQjtJQUNwRCxrQkFBa0IsRUFBRSxvQkFBb0I7SUFDeEMsMkJBQTJCLEVBQUUsNkJBQTZCO0lBQzFELHlCQUF5QixFQUFFLDJCQUEyQjtJQUN0RCxrQ0FBa0MsRUFBRSxvQ0FBb0M7SUFDeEUsV0FBVyxFQUFFLGFBQWE7SUFDMUIsY0FBYyxFQUFFLGdCQUFnQjtJQUNoQyxrQkFBa0IsRUFBRSxvQkFBb0I7SUFDeEMsV0FBVyxFQUFFLGFBQWE7SUFDMUIsaUJBQWlCLEVBQUUsbUJBQW1CO0lBQ3RDLDRCQUE0QixFQUFFLDhCQUE4QjtJQUM1RCxpQkFBaUIsRUFBRSxtQkFBbUI7SUFDdEMsc0JBQXNCLEVBQUUsd0JBQXdCO0lBQ2hELDRCQUE0QixFQUFFLDhCQUE4QjtJQUM1RCxzQkFBc0IsRUFBRSx3QkFBd0I7SUFDaEQsdUJBQXVCLEVBQUUseUJBQXlCO0lBQ2xELDZCQUE2QixFQUFFLCtCQUErQjtJQUM5RCwrQkFBK0IsRUFBRSxpQ0FBaUM7SUFDbEUsZ0JBQWdCLEVBQUUsa0JBQWtCO0lBQ3BDLDJCQUEyQixFQUFFLDZCQUE2QjtDQUMzRCxDQUFDO0FBRUYsZUFBZSxJQUFJLENBQUMifQ==